import { styled } from '../theme';
import Small from './Small';

const FieldLabel = styled(Small.withComponent('label'))(({ theme }) => ({
    fontFamily: theme.typography.fontFamily.heavy,
    fontWeight: theme.typography.fontWeight.bold,
    fontSize: '1.3rem',
    lineHeight: '1.8rem',
    color: theme.color.gray70,
    marginBottom: 0,
    opacity: 0.4,
    textTransform: 'uppercase',
}));

export default FieldLabel;
